import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { ChecklistIcon } from "~/components/ui/icons/checklist";

export const InvoiceLockedSaleEndedNeedActions: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Alert className="border-[#F3D9B3] bg-[#FBF2E6] [&>svg]:text-orange-600">
      <ChecklistIcon className="size-10" />
      <AlertTitle>
        {t("invoice.invoice_locked.sale_ended_need_actions.sale_is_over_but")}
      </AlertTitle>
      <AlertDescription>
        {t(
          "invoice.invoice_locked.sale_ended_need_actions.billing_available_fulfilled_requirements",
        )}
      </AlertDescription>
    </Alert>
  );
};
